import React, { useEffect } from 'react';
import { loadCalendly } from './lib/calendly';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Stats from './components/Stats';
import Services from './components/Services';
import Features from './components/Features';
import CaseStudies from './components/CaseStudies';
import Process from './components/Process';
import Integrations from './components/Integrations';
import Testimonials from './components/Testimonials';
import Team from './components/Team';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './index.css';

const App: React.FC = () => {
  // Warm up the Calendly popup widget so booking CTAs open instantly.
  useEffect(() => {
    loadCalendly().catch(() => {/* CTAs fall back to a direct link */});
  }, []);

  return (
    <div className="relative bg-navy-900 min-h-screen text-text-main font-sans antialiased overflow-x-hidden">
      {/* page-wide noise texture */}
      <div className="pointer-events-none fixed inset-0 bg-noise opacity-[0.015] mix-blend-soft-light z-[1]" />
      <Navbar />
      <main className="relative z-[2]">
        <Hero />
        <Stats />
        <Services />
        <Features />
        <CaseStudies />
        <Process />
        <Integrations />
        <Testimonials />
        <Team />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default App;
